<template>
	<v-expansion-panel-content :expand-icon="iconClass" v-model="isCollapsed">
		<div slot="header">{{ question }}</div>
		<div class="answer" v-html="answer"></div>
	</v-expansion-panel-content>
</template>

<script>
export default {
	name: 'FaqAccordion',
	data() {
		return {
			isCollapsed: false
		}
	},
	props: {
		question: {
			type: String,
			required: true
		},
		answer: {
			type: String,
			required: true
		}
	},
	computed: {
		iconClass() {
			return this.isCollapsed ? 'glyphicon-minus' : 'glyphicon-plus';
		}
	}
}
</script>

<style scoped></style>
